import ConcluirContainer from './concluir.container'

export default ConcluirContainer
